import { getUnixTime } from "date-fns/esm";
import { NetworkStatus } from "@apollo/client";

import useGetChangeFailureRateRange from "shared/DoraMetrics/useGetChangeFailureRateRange";

import useDoraDateRange from "../useDateRange";

const useDoraChangeFailureRateRange = () => {
  const { startTime, endTime } = useDoraDateRange();

  const { range, hasRuns, loading, error, refetch, networkStatus } = useGetChangeFailureRateRange({
    startTimeUnix: getUnixTime(startTime),
    endTimeUnix: getUnixTime(endTime),
  });

  const isLoading = (loading && !range) || networkStatus === NetworkStatus.refetch;

  return {
    range,
    hasRuns,
    isLoading,
    error,
    refetch,
  };
};

export default useDoraChangeFailureRateRange;
